<template>
  <div>
    <SimpleMarketplaceSidebar />
    <div data-smooth-scroll="main" class="marketplace-body-footer-container d-flex flex-column vh-100 overflow-x-hidden">
      <div class="d-flex flex-lg-grow-1 align-items-center align-items-lg-start flex-column mb-auto">
        <div class="px-3 px-lg-0 py-lg-0 marketplace-page">
          <slot />
        </div>
      </div>
      <div class="d-flex align-content-between flex-column mt-auto">
        <MarketplaceFooter class="mb-3" />
      </div>
    </div>
  </div>
</template>

<script>
import MarketplaceFooter from '~/components/marketplace/MarketplaceFooter'
import SimpleMarketplaceSidebar from "~/components/marketplace/SimpleMarketplaceSidebar";

export default {
  components: {
    MarketplaceFooter,
    SimpleMarketplaceSidebar,
  }
}
</script>

<style lang="scss">

.marketplace-body-footer-container {
  @include media-breakpoint-up(lg) {
    padding-left: 400px;
  }
}
.marketplace-page {
  margin-top: 90px; /* Spaced to match .sidebar-nav in MarketplaceSidebar minus back btn and 16 margin */
  width: 100%;
  @include media-breakpoint-down(lg) {
    max-width: 365px;
  }
  @include media-breakpoint-up(xl) {
    width: 600px;
  }
  @include media-breakpoint-down(sm) {
    width: 90%
  }
  @include media-breakpoint-down(sm) {
    width: 100%
  }
  .no-value-select {
    color: $type-400
  }
}
.no-back-button-padding {
  padding-top: 58px; /* When a back button is included it takes up 58px */
}

.marketplace-header {
  :not(h3) {
    color: $type-500
  }
}

.marketplace-content {
  > * {
    margin-bottom: 24px;
  }
}

.marketplace-content > :last-child {
  margin-bottom: 32px !important;
}

.marketplace-content > *:not(.marketplace-content-wide) {
  max-width: 400px;
}

.marketplace-content-wide {
  @include media-breakpoint-up(xl) {
    width: 600px
  }
}

.mp-transition-enter-active {
  left: 100%;
  opacity: 0;
  transition: left 0.25s ease-out, opacity 0.15s ease-out;
}
.mp-transition-enter-active {
  position: relative;
}
.mp-transition-enter-to {
  opacity: 1;
  left: 0%;
}

.mp-transition-back-enter-active {
  right: 100%;
  opacity: 0;
  transition: right 0.25s ease-out, opacity 0.15s ease-out;
}
.mp-transition-back-enter-active {
  position: relative;
  @include media-breakpoint-up(lg) {
    right: 10%;
  }
}
.mp-transition-back-enter-to {
  opacity: 1;
  right: 0%;
}

.mp-transition-leave, .mp-transition-back-leave {
  opacity: 1;
}
.mp-transition-leave-active, .mp-transition-back-leave-active {
  transition: opacity 0.15s linear;
}
.mp-transition-leave-to, .mp-transition-back-leave-to {
  opacity: 0;
}
</style>
